<template>
  <div class="app-container">
    <side-menu />
    <div class="main-container">
      <top-nav />
      <div class="content-container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from './SideMenu.vue'
import TopNav from './TopNav.vue'

export default {
  name: 'MainLayoutNav',
  components: {
    SideMenu,
    TopNav
  },
  mounted () {
    // 进入主布局时统一拉取一次系统设置
    this.$store.dispatch('fetchSystemSettings')
  }
}
</script>

<style scoped>
.app-container {
  display: flex;
  height: 100vh;
  background-color: #f5f7fa;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-container {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
</style>
